import { CanActivateFn } from '@angular/router';
import { LogService } from '../services/log.service';
import { Log } from '../models/log';
import { inject } from '@angular/core';

export const mindlogRegistrationGuard: CanActivateFn = (route, state) => {
  
  const logService: LogService<Log> = inject(LogService);

  if(logService.canAccessMindLogRegister()){
    return true;
  }

  return false;

};
